module.exports = __webpack_public_path__ + "img/individuel.f7dcaa9a.jpg";